import React from 'react'
import { connect } from 'react-redux'

import Paginator from './Paginator'
import { fetchJobs } from './jobs-reducer'
import { changePage } from './pagination-reducer'

const PaginatorContainer = ({
  pages,
  startkey,
  fetchJobs,
  changePage,
  currentPage
}) => {
  const handleNext = () => {
    if (pages[currentPage + 1]) {
      return changePage(currentPage + 1)
    }
    fetchJobs({startkey})
  }

  const handlePrev = () => {
    const nextPage = currentPage - 1
    if (currentPage < 0) {
      return
    }
    changePage(nextPage)
  }

  return (
    <Paginator
      onNext={handleNext}
      onPrev={handlePrev}
      isPrevDisabled={currentPage === 0}
    />
  )
}

const mapStateToProps = ({pagination}) => ({...pagination})
const mapDispatchToProps = {
  fetchJobs,
  changePage
}

export default connect(mapStateToProps, mapDispatchToProps)(PaginatorContainer)



// WEBPACK FOOTER //
// ./src/jobs/PaginatorContainer.js